import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=c041d754&scoped=true&"
import script from "./tipDialog.vue?vue&type=script&lang=js&"
export * from "./tipDialog.vue?vue&type=script&lang=js&"
import style0 from "./tipDialog.vue?vue&type=style&index=0&id=c041d754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c041d754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c041d754')) {
      api.createRecord('c041d754', component.options)
    } else {
      api.reload('c041d754', component.options)
    }
    module.hot.accept("./tipDialog.vue?vue&type=template&id=c041d754&scoped=true&", function () {
      api.rerender('c041d754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleComponents/tipDialog.vue"
export default component.exports